import { formatDateTime } from '@factorin/util';

import { issuerNameTagsTranslations, subjectNameTagsTranslations, parseCertInfo } from './utils';
import {
    CertificateNotValidError,
    GetCertificatePropError,
    ExportCertificateError,
    GetCertificateAlgorithmError,
    GetCertificateInfoError,
} from './errors';


const wrapMethod = (Error, getter) => async (...args) => {
    try {
        return await getter(...args);
    } catch ({ message }) {
        throw new Error(message);
    }
};

export class Certificate {
    constructor(item) {
        this._cert = item._cert;
        this.thumbprint = item.thumbprint;
        this.subjectName = item.subjectName;
        this.issuerName = item.issuerName;
        this.validFrom = new Date(item.validFrom);
        this.validTo = new Date(item.validTo);

        const name = item.subjectName.match(/CN=(.+?)(?:,|$)/);
        if (name && name[1])
            this.name = name[1];

        this.label = `${this.name || this.subjectName} (до ${formatDateTime(this.validTo)})`;

        (window.$certs || (window.$certs = {}))[this.name] = this;
    }

    isValid = wrapMethod(
        CertificateNotValidError,
        async () => {
            const validation = await this._cert.IsValid();
            return validation.Result;
        },
    );

    getProp = wrapMethod(
        GetCertificatePropError,
        async propName => this._cert[propName],
    );

    exportBase64 = wrapMethod(
        ExportCertificateError,
        async () => this._cert.Export(0),
    );

    getAlgorithm = wrapMethod(
        GetCertificateAlgorithmError,
        async () => {
            const publicKey = await this._cert.PublicKey();
            const algorithm = await publicKey.Algorithm;
            return {
                algorithm: await algorithm.FriendlyName,
                oid: await algorithm.Value,
            };
        },
    );

    getInfo = wrapMethod(
        GetCertificateInfoError,
        async (tags, propName) => {
            const propInfo = await this._cert[propName];
            return parseCertInfo(tags, propInfo);
        },
    );

    getOwnerInfo = async () => this.getInfo(subjectNameTagsTranslations, 'SubjectName');

    getIssuerInfo = async () => this.getInfo(issuerNameTagsTranslations, 'IssuerName');
}
